var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.91158 0.22069L16.4116 12.2307C16.5132 12.3835 16.521 12.5804 16.4316 12.7407C16.3421 12.8999 16.1742 12.9991 15.9916 13.0007H0.99158C0.814085 12.9901 0.654939 12.8878 0.57158 12.7307C0.47614 12.5741 0.47614 12.3773 0.57158 12.2207L8.07158 0.22069C8.16676 0.0825201 8.3238 0 8.49158 0C8.65936 0 8.8164 0.0825201 8.91158 0.22069ZM8.49158 1.43069L1.89158 12.0007H15.0916L8.49158 1.43069ZM7.99158 5.49069V8.49069C7.99158 8.76683 8.21544 8.99069 8.49158 8.99069C8.76772 8.99069 8.99158 8.76683 8.99158 8.49069V5.49069C8.99158 5.21455 8.76772 4.99069 8.49158 4.99069C8.21544 4.99069 7.99158 5.21455 7.99158 5.49069ZM8.14151 9.64773C8.2337 9.55366 8.35987 9.50066 8.49158 9.50069C8.62591 9.498 8.75567 9.54949 8.85162 9.64355C8.94756 9.73761 9.00161 9.86633 9.00158 10.0007C9.00158 10.2768 8.77772 10.5007 8.50158 10.5007C8.22544 10.5007 8.00158 10.2768 8.00158 10.0007C7.99889 9.86901 8.04933 9.74179 8.14151 9.64773Z",
    fill: "#EE1B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.c8015c1d5292f013714da688b54daffb.svg";
export { ForwardRef as ReactComponent };